import { booleanAttribute, Component, computed, input, output } from '@angular/core';
import { ISvcMulticolorProgress } from './interfaces/svc-multicolor-progress.interface';

@Component({
  selector: 'svc-multicolor-progress-bar',
  templateUrl: './svc-multicolor-progress-bar.component.html',
  styleUrls: ['./svc-multicolor-progress-bar.component.scss'],
})
export class SvcMultiColorProgressBarComponent {
  progressData = input<ISvcMulticolorProgress>();
  barLabel = input<'percentage' | 'value' | 'none'>('percentage');
  /**
   * Opt-in accessibility for bars whose segments actually navigate somewhere (drilldowns).
   * When true each segment renders as a real `<button>`, so it is focusable, operable with
   * Enter/Space and announced with `ariaLabel`. Defaults to false: read-only bars keep the
   * original non-focusable markup and add no tab stops to their rows.
   */
  interactive = input(false, { transform: booleanAttribute });

  mouseEnter = output<void>();
  mouseLeave = output<void>();
  mouseEnterColumn = output<any>();
  mouseLeaveColumn = output<any>();
  mouseClickColumn = output<any>();

  filteredData = computed(() => {
    const data = this.progressData();
    if (!data) return [];
    const labelType = this.barLabel();
    return data.data.filter((c) => c.value).map((item) => {
      const width = this.whichProgress(data.total, item.value);
      const barText = this.getBarText(item.value, width, labelType);
      return { ...item, width, barText, minWidth: this.getMinWidth(barText) };
    });
  });

  getBarText(value: number, width: number, labelType: 'percentage' | 'value' | 'none'): string {
    if (labelType === 'none') return '';
    if (labelType === 'value') return `${value}`;
    return `${width}%`;
  }

  eventMouseEnter() {
    this.mouseEnter.emit();
  }
  eventMouseLeave() {
    this.mouseLeave.emit();
  }
  eventMouseEnterColumn(column: any) {
    this.mouseEnterColumn.emit(column);
  }
  eventMouseLeaveColumn(column: any) {
    this.mouseLeaveColumn.emit(column);
  }

  whichProgress(totalValue: number, progress: number) {
    try {
      return Math.round((+progress * 100) / totalValue);
    } catch {
      return progress;
    }
  }

  getMinWidth(label: string) {
    const charWidth = 12;
    const padding = 1;
    return label.length * charWidth + padding;
  }

  eventMouseClickColumn(item: any) {
    this.mouseClickColumn.emit(item);
  }

  /**
   * Click on the segment container. On an interactive bar the inner button already emitted
   * and the event only bubbled up here, so emitting again would double-fire the drilldown.
   */
  eventSegmentContainerClick(item: any) {
    if (this.interactive()) return;
    this.eventMouseClickColumn(item);
  }
}
